import { Dialog, DialogContent, DialogActions, DialogTitle, Button, Grid, Card, Chip, IconButton } from '@mui/material'
import GpsFixedIcon from '@mui/icons-material/GpsFixed';

const ModalDetalles = ({ open, onClose, data }) => {

    const catalogoChips = {

        "LOW": <Chip label="LOW" color="primary" />,
        "MEDIUM": <Chip label="MEDIUM" color="warning" />,
        "HIGH": <Chip label="HIGH" color="error" />,

    }

    return (

        <Dialog
            open={open}
            onClose={onClose}
        >

            {/* HEADER */}

            <DialogTitle 
                sx={{ 
                    textAlign: 'center', 
                    backgroundColor: '#4375cc', 
                    color: 'white',
                    fontWeight: 700,
                    marginBottom: 2
                }}
            >
                Detalles
            </DialogTitle>

            {/* BODY */}

            <DialogContent>

                <Grid container spacing={2} mt={1}>

                    <Grid size={3}>
                        <strong>Unidad:</strong> {data.vehicle}
                    </Grid>

                    <Grid size={9}>
                        <strong>Driver:</strong> {data.driver !== null ? data.driver : 'N/A'}
                    </Grid>

                    <Grid size={12}>
                        <strong>Ubicación:</strong> {data.location} 
                        <IconButton
                            href={data.incident_url} 
                            target="_blank"
                            sx={{
                                color: 'blue'
                            }}
                        >
                            <GpsFixedIcon/>
                        </IconButton>
                    </Grid>

                    <Grid size={12}>
                        <strong>Motivo del Retraso:</strong> {data.reason}
                    </Grid> 

                    <Grid size={6}>
                        <strong>Fecha Evento:</strong> {data.fecha_evento}
                    </Grid>

                    <Grid size={6}>
                        <strong>Fecha Cierre:</strong> {data.fecha_cierre || 'Pendiente'}
                    </Grid>

                    <Grid size={6}>
                        <strong>Duración:</strong> {data.duracion}
                    </Grid>

                    <Grid size={6}>
                        <strong>Gravedad:</strong> {catalogoChips[data.severity]}
                    </Grid>

                    <Grid size={12}>
                        <strong>Solución:</strong>
                        <Card sx={{ p: 2, mt: 1 }}>
                            {data.solucion || 'Sin solución registrada'}
                        </Card>
                    </Grid>

                </Grid>

            </DialogContent>

            <DialogActions sx={{ justifyContent: 'center', marginBottom: 2 }}>
                <Button onClick={onClose} variant="contained" sx={{ backgroundColor: 'grey', color: 'white' }}>
                    Cerrar
                </Button>
            </DialogActions>

        </Dialog>

    )

}

export default ModalDetalles